import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Modal, Select, Input, Button } from 'antd'

import CategorySelect from '@components/CategorySelect/'

import { policies } from '@services/api'

import * as styles from './styles.scss'

@inject((store: any) => {
    const { popupStore, categoriesStore } = store
    return { popupStore, categoriesStore }
})
@observer
class AddPolicyPopup extends Component<any, any> {
    state: any = {
        policyInfo: {},
        errors: {}
    }

    componentDidMount() {
        this.getCategories()
    }

    getCategories = async () => {
        await this.props.categoriesStore.resetSelectedCategories()
        await this.props.categoriesStore.updateCategoriesList('POLICY', ['name', 'id', 'parent_id'])
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    setError = (errorName, errorMsg) => {
        this.props.popupStore.addErrors(errorName, errorMsg)
        return false
    }

    validatePolicy = () => {
        const { policyInfo } = this.state
        if (!policyInfo['name']) {
            return this.setError('nameError', 'חובה למלא את שם הפוליסה')
        } else {
            return true
        }
    }

    savePolicy = async () => {
        const { company_id } = this.props.popupStore.info
        const { policyInfo } = this.state

        if (this.validatePolicy()) {
            try {
                const policy = await policies.addPolicy({ company_id, ...policyInfo })
                this.closePopup()
                this.props.history.push(`/insurance/${company_id}/${policy.data.id}`)
            } catch (e) {
                this.setError('serverError', 'קיימת בעיה בחיבור לשרת')
            }
        }
    }

    setValue = (value, name) => {
        this.setState(prevState => ({ ...prevState, policyInfo: { ...prevState.policyInfo, [name]: value } }))
    }

    render() {
        const { name } = this.state.policyInfo
        const { popupStore } = this.props
        const { company } = popupStore.info
        const { nameError, serverErrors } = popupStore.errors

        const styles = {
            input: { direction: 'ltr', textAlign: 'right' },
            title: { fontSize: '0.8rem', fontWeight: 500, width: '6rem', textAlign: 'right', display: 'inline-block' },
            select: { width: '100%' },
            date: { border: 'none', cursor: 'pointer', width: '100%' },
            cardHead: { borderBottom: 'none', backgroundColor: '#e1e3e7' },
            cardBody: { padding: '0.1rem', backgroundColor: '#fafafa' },
            cardStyle: { marginBottom: '0.5rem' },
            checkBox: { padding: '0.5rem' }
        } as React.CSSProperties

        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <div style={{ float: 'left', display: 'inline-block' }}>
                    <Button onClick={this.closePopup}>סגור</Button>
                    <Button type="primary" onClick={this.savePolicy}>
                        הוסף פוליסה
                    </Button>
                </div>
            </div>
        )

        return (
            <Modal
                title={`הוספת פוליסה ל${company}`}
                visible={popupStore.popupType === 'addPolicy'}
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                {serverErrors ? <span className={styles.server_error}>{serverErrors[0].message}</span> : ''}

                <Input
                    placeholder="שם הפוליסה"
                    value={name}
                    autoComplete="off"
                    name="name"
                    onChange={e => this.setValue(e.target.value, 'name')}
                />
                {nameError ? <span className={styles.error}>{nameError}</span> : ''}
            </Modal>
        )
    }
}

export default withRouter(AddPolicyPopup)
